import { render, staticRenderFns } from "./ProductPageScreenBracelet.vue?vue&type=template&id=2c588c7b&scoped=true&"
import script from "./ProductPageScreenBracelet.vue?vue&type=script&lang=js&"
export * from "./ProductPageScreenBracelet.vue?vue&type=script&lang=js&"
import style0 from "./ProductPageScreenBracelet.vue?vue&type=style&index=0&id=2c588c7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c588c7b",
  null
  
)

export default component.exports